export enum LockersStatusText {
	free = 'Активный',
	busy = 'Заблокирован'
}

export enum LockersStatusColor {
	free = '#24D321',
	busy = '#ED4141'
}
